import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}

  transform(item: any, _search: string): any {
    const search = _search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
    return this.dom.bypassSecurityTrustHtml(item.replace(re, '<span style="font-weight: bold">$1</span>'));
  }
}
